/** Column Labels for Model, Parametric Analysis, and Community Dashboard Tables 
 * Keys must match the property names in the model/folder/community objects
 * Only add "actions" to display three dots icon beside each item
*/
export const columnHeadings = {
    modelDir: {
        name: "Name",
        lastEdited: "Last Modified",
        actions: "Create",
    },
    commDir: {
        name: "Name",
        size: "Total size",
        region: "Region",
        lastEdited: "Last Modified",
        actions: "New",
    },
    renoCommModelDir: {
        name: "Name",
        userName: "User",
        provTerr: "Province",
        currentPhase: "Current Phase",
        lastEdited: "Last Modified",
        targetCompletionDate: "Target Completion",
    },
    commModelDir: {
        name: "Name",
        weatherRegion: "Region/Location", // update key?
        countDirection: "Count & Direction",
        status: "Status",
        lastEdited: "Last Modified",
        actions: "Add",
    },
    parametricDir: {
        name: "Name",
        lastEdited: "Last Modified",
        actions: "New",
    },
};